<template>
  <div class="white-box position-relative">
    <TileLoader :loading="loading"/>
    <div class="header-container">
      <h2>Souscriptions {{ prestas && prestas.length > 0 ? prestas[0].Year : '' }} HT</h2>
      <strong v-if="prestas && prestas.length > 0">
        Total : {{ formatEuro(totalInvoiced)}}
      </strong>
    </div>
    <div class="prestas-table">
      <template v-for="presta of prestas">
        <div>{{presta.Label}}</div>
        <div class="tag">
          <div :class="presta.Price ? 'green' : 'red'"/>
        </div>
        <div class="number">{{ presta.Price ? formatEuro(presta.Price) : '' }}</div>
      </template>
    </div>
  </div>

</template>

<script>
import TileLoader from "../../Dashboards/TileLoader.vue";
import {getFrsPrestasInfos, getPaymentsFrs} from "@/utils/dashboardCdm";

export default {
  components: {TileLoader},
  name: 'FrsPrestasTile',
  props: ["frsGuid"],
  data() {
    return {
      loading: 0,
      prestas: []
    }
  },
  mounted() {
    this.initData();
  },
  watch: {
    frsGuid() {
      this.initData();
    }
  },
  methods: {
    initData() {
      if (!this.frsGuid) return;

      this.prestas = null;
      this.loading = 1;
      getFrsPrestasInfos(this.frsGuid).then(res => {
        if (res)
          this.prestas = res;
        this.loading = 0;
      })
    },
    formatEuro(value) {
      return Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR', maximumFractionDigits: 0}).format(value);
    },
  },
  computed: {
    totalInvoiced() {
      return this.prestas.reduce((acc, cur) => acc + cur.Price, 0);
    }
  }
}
</script>

<style scoped>
.white-box {
  flex: 0.4 1 20em;
  padding: 12px;

  display: flex;
  flex-direction: column;
}

.header-container {
  display: flex;
  justify-content: space-between;
}

h2 {
  display: flex;
  align-items: center;

  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

p {
  margin: 0;
}

.prestas-table {
  display: grid;
  grid-template-columns: 1fr min-content max-content;
  column-gap: 12px;
  row-gap: 4px;
}


.prestas-table .number {
  text-align: right;
}

.prestas-table .tag > div {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.prestas-table .tag > div.green {
  background-color: #388E3C;
}

.prestas-table .tag > div.orange {
  background-color: #FFC107;
}

.prestas-table .tag > div.red {
  background-color: #D32F2F;
}

</style>



// WEBPACK FOOTER //
// src/components/DashboardCdm/RecapPage/FrsPrestasTile.vue